export default __webpack_public_path__ + "static/bunker-web-2-mobile-6441ca6420d6477884c25fd402bca9f6.jpg";